export default {
  appId: '66e440188c31fa1f7fa27a0e',
  apiUrl: 'https://api.bricodes.com',
  storageUrl: 'https://storage.bricodes.com',
  sentryDsn: 'https://ef8a0eaf088f44d1b86bda92dd989f73@sentry.io/1503419',
  languageCode: 'pl',
};
